import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { CustomPropertiesData, GetAttachmentModel } from "@tSurya/Services/SurGetCustomPropertiesService";
import { GetCustomPropertiesDataState } from "@tSurya/Store/Data/SurGetCustomPropertiesState";
import { Draft } from "immer";

const initialState: GetCustomPropertiesDataState = {
    isLoading: false,
    customIdData: null,
    customUserProfileData: null,
    customAccountApprove: null,
    attachmentFile: null,
    attachmentFileName: null,
    AccountReject: null,
};

const reducer = {
    "Custom/AccountApprove/BeginLoadAccountApprove": (draft: Draft<GetCustomPropertiesDataState>) => {
        draft.isLoading = true;
    },
    "Custom/AccountApprove/CompletedLoadAccountApprove": (
        draft: Draft<GetCustomPropertiesDataState>,
        action: { result: CustomPropertiesData },
    ) => {
        draft.isLoading = false;
        draft.customAccountApprove = action.result;
    },
    "Custom/GetAttachmentFileName/BeginLoadGetAttachmentFileName": (draft: Draft<GetCustomPropertiesDataState>) => {
        draft.isLoading = true;
    },
    "Custom/GetAttachmentFileName/CompletedLoadGetAttachmentFileName": (
        draft: Draft<GetCustomPropertiesDataState>,
        action: { result: GetAttachmentModel },
    ) => {
        draft.isLoading = false;
        draft.attachmentFileName = action.result;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
